import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterSidebarMerchants } from '@components/molecules/filters/FilterSidebarMerchants';
import { ResultsContainer } from '@components/organisms/ResultsContainer';
import { StickyHeader } from '@components/molecules/StickyHeader/StickyHeader';
import { ServiceCardProps } from '@components/molecules/ServiceCard';
import { BreadcrumbsBanner } from '@components/molecules/BreadcrumbsBanner';
import { MarketplaceAdvertising } from '@components/molecules/MarketplaceAdvertising';
import { Footer } from '@components/molecules/Footer';
import { Container } from '@components/atoms/Container';
import { Space } from '@components/atoms/Space';
import { useInfiniteScroll } from '@hooks/useInfiniteScroll';
import { useData } from '@hooks/useData';
import { useFilters } from '@hooks/useFilters';
import { useCustomNavigate } from '@hooks/useCustomNavigate';
import { updateUrlSearchParams } from '@utils/search';
import { MenuPages, ResultsType } from '@types';
import { getDynamicMenuItemValue } from '@utils/translation';

export const Merchants: FC = () => {
    const { navigate } = useCustomNavigate();
    const { stores, isLoadingStores, allSettings } = useData();
    const { results } = useFilters();
    const { pageToRequest, checkPageToRequest, observerRef } = useInfiniteScroll();
    const { t } = useTranslation();

    const pageTitle = getDynamicMenuItemValue(allSettings?.data, 3);

    const translations = {
        title: pageTitle,
        orderNameAsc: t('sort-options.name_asc'),
        orderCreatedAtDesc: t('sort-options.created_at_desc'),
    };

    const handleOrderChange = (value: string) => {
        const updatedUrl = updateUrlSearchParams({ order: [value] });
        navigate(updatedUrl);
    };

    return (
        <>
            <StickyHeader menuActivePage={MenuPages.Merchants} />

            <Container>
                <BreadcrumbsBanner title={translations.title} links={[]} currentPage={translations.title} />
            </Container>

            <Space spaceBreakpoints={{ xs: { space: 50 } }} />

            <ResultsContainer
                type={ResultsType.merchants}
                results={results as ServiceCardProps[]}
                scrollObserverRef={observerRef}
                filters={<FilterSidebarMerchants pageToRequest={pageToRequest} checkPageToRequest={checkPageToRequest} />}
                total={stores?.pagination?.total || 0}
                order={{
                    options: [
                        { value: 'name_asc', text: translations.orderNameAsc },
                        { value: 'created_at_desc', text: translations.orderCreatedAtDesc },
                    ],
                    onChange: handleOrderChange,
                }}
                loading={isLoadingStores}
            />

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <MarketplaceAdvertising />

            <Footer mode="normal" />
        </>
    );
};
